import axios from "axios";
import url from "./Url";
import moment from "moment";

const instance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
  transformRequest: [
    function (data, headers) {
      if (data instanceof FormData) {
        return data;
      } else {
        Date.prototype.toJSON = function () {
          return moment(this).format("YYYY-MM-DDTHH:mm:ss");
        };
        return JSON.stringify(data);
      }
    },
  ],
});

export default instance;
